import {PostB2BBeneficiaryAuthorizationParams} from 'domain/usecases/private/profile/post-b2b-beneficiary-authorization';
import {makePostB2BBeneficiaryAuthorization} from 'main/factories/usecases/private/profile/post-b2b-beneficiary-authorization-factory';

export const postB2BBeneficiaryAuthorization = async (
	params: PostB2BBeneficiaryAuthorizationParams,
) => makePostB2BBeneficiaryAuthorization().post(params);
